module.exports = __webpack_public_path__ + "static/media/icon_request.6b9d6db0.svg";